// extracted by mini-css-extract-plugin
export var errorIcon = "_jz-1";
export var nameLogo = "_jz-0";